module.exports = __webpack_public_path__ + "static/media/Mitsubachi-6.69292be1.jpg";